import { ReactComponent as Arrow } from '../../../../icons/select/ChevronSelect.svg'
import styles from './DropdownIndicator.module.scss'
import { components } from 'react-select'
import React from 'react'

const DropdownIndicator = (props) => {
  const { isFocused, selectProps } = props

  return (
    <components.DropdownIndicator {...props}>
      {selectProps.icon ? (
        <span className={styles['custom-icon']}>{selectProps.icon}</span>
      ) : (
        <Arrow
          className={
            isFocused && selectProps.menuIsOpen
              ? `${styles.icon} ${styles.active}`
              : styles.icon
          }
        />
      )}
    </components.DropdownIndicator>
  )
}

export { DropdownIndicator }
